import { debounce } from "lodash"

// Debounce a per-borrower save without losing track of whose edit it was.
//
// The borrower is read with getTarget() when the field changes and handed to invoke(target, ...args)
// when the save fires. Reading the active borrower at fire time instead sent one borrower's edits
// under another's partyId whenever the LO switched borrower cards inside the debounce window.
// A save still pending for a different borrower is fired first, so the new one cannot replace it.
export const partyDebouncedSave = (invoke, wait, getTarget) => {
    let pendingPartyId = null
    const debounced = debounce((target, ...args) => {
        pendingPartyId = null
        return invoke(target, ...args)
    }, wait)
    const save = (...args) => {
        const target = getTarget()
        const partyId = target?.partyId || ""
        if (pendingPartyId !== null && pendingPartyId !== partyId) debounced.flush()
        pendingPartyId = partyId
        return debounced(target, ...args)
    }
    save.cancel = () => {
        pendingPartyId = null
        debounced.cancel()
    }
    save.flush = () => debounced.flush()
    return save
}
